const moment = require('moment');

export default class EvergreenSlot {
  slotType = 'evergreen';

  constructor(time) {
    this.time = time;
    this.midnight = moment(time).startOf('day').toISOString();
  }

  isEmpty() {
    return false;
  }
}
